type TimelineHelpersModule =
  typeof import('components/organisms/projects/project-plan/timeline/helpers');

let modulePromise: Promise<TimelineHelpersModule> | null = null;
let cachedModule: TimelineHelpersModule | null = null;

export const loadProjectPlanTimelineHelpers =
  (): Promise<TimelineHelpersModule> => {
    if (!modulePromise) {
      modulePromise = import(
        'components/organisms/projects/project-plan/timeline/helpers'
      ).then((module) => {
        cachedModule = module;

        return module;
      });
    }

    return modulePromise;
  };

export const getCachedProjectPlanTimelineHelpers =
  (): TimelineHelpersModule | null => cachedModule;
